import { client } from 'src/client';
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
import { bus } from '@/util/event-bus';
import { handleAuthorized } from '@/util/router-helpers';

export const auth = {
   namespaced: true,
   state: {
      user: null,
      verified: false,
   },
   getters: {
      loggedIn: state => state.user !== null && state.verified,
      hasUser: state => state.user !== null,
      verifiedUser: state => (state.verified ? state.user : null),
   },
   mutations: {
      setUserAndToken(state, data) {
         state.user = data.user;
         LocalStorage.set('user', data);
      },
      setBearerToken(state, token) {
         client.defaults.headers.common.Authorization = `Bearer ${token}`;
      },
      logout(state) {
         LocalStorage.remove('user');
         state.user = null;
         state.verified = false;
         delete client.defaults.headers.common.Authorization;
      },
      authVerified(state, verified) {
         state.verified = verified;
         if (verified) {
            bus.$emit('auth-ok');
         }
      },
   },
   actions: {
      async init({ commit, state }) {
         return new Promise((resolve, reject) => client.get('/sanctum/csrf-cookie')
            .then(() => {
               client.get('/api/ping')
                  .then(({ data }) => {
                     if (data.user) {
                        if (!state.user) {
                           commit('setUserAndToken', {
                              user: data.user,
                              token: null,
                           });
                        }
                        commit('authVerified', true);
                        handleAuthorized();
                        return resolve();
                     }
                     return reject();
                  });
            }));
      },
      async sessionLogin({ commit }, params) {
         return client.post('/login', params)
            .then(({ data }) => {
               commit('setUserAndToken', {
                  user: data,
                  token: null,
               });
               commit('authVerified', true);
               handleAuthorized();
            });
      },
      async sessionLogout({ commit }) {
         commit('logout');
         return client.post('/logout');
      },
      async login({ commit }, params) {
         params.device_name = 'Frontend';
         return client.post('/sanctum/token', params)
            .then(({ data }) => {
               commit('setUserAndToken', data.user);
               commit('setBearerToken', data.token);
               commit('authVerified', true);
               handleAuthorized();
            });
      },
   },
};
